// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"AZ-z","subtitle":"BZ-z","wrapper":"CZ-z","leftArrow":"DZ-z","rightArrow":"EZ-z"};